module.exports = __webpack_public_path__ + "static/media/Footer Logo 2.5f7d8e12.png";